import { Injectable } from '@angular/core';
import { HttpApiService } from '../core/authentication/services/http-api.service';
import { userApi } from '../core/model/constants/endpoints';
import { filter, from, Observable, Subject } from 'rxjs';
import { CommonService } from '../core/services/common.service';
import { FormGroup } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { cultureSelctor } from '../store/selectors/shared.selector';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  togglePhoneSidenav = new Subject();
  constructor(
    private commonService: CommonService,
    private http: HttpClient
  ) { }


  getUserProfile(): Observable<any> {
    const userProfileApi = this.commonService.httpApiService.get(`${userApi.getUserDetail}`);
    return from(userProfileApi);
  }

  getCountryCulture(): Observable<any> {
    const userProfileApi = this.commonService.httpApiService.get(`${userApi.getCulture}`);
    return from(userProfileApi);
  }

  public isFieldInvalid(fieldName: string, form: FormGroup): boolean {
    const control = form?.get(fieldName);
    return !!(control && control.invalid && (control.touched || control.dirty));
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  async getculter() {
    let CountryCulture = await this.commonService.store.select(cultureSelctor);
    return CountryCulture;
  }

  getChatBot(messages: any, panelistId: any) {
    const formData = new FormData();
    formData.append("message", messages);
    return this.http.post(`${environment.botDomain}${userApi.botChat}?id=${panelistId}`, formData)
  }
  botfeedBack(isSatisfy: any, messageId: any) {
    const formData = new FormData();
    formData.append("isSatisfy", isSatisfy);
    return this.http.post(`${environment.botDomain}${userApi.botfeedBack}?id=${messageId}`, formData)
  }

  getDefaultChat(language: string = 'en', panelistId?: number, category?: string, subCategory?: string) {
    let params = new HttpParams();

    if (language) {
      params = params.set('language_code', language);
    }
    if (panelistId) {
      params = params.set('panelist_id', panelistId.toString());
    }
    if (category) {
      params = params.set('category', category); // HttpParams auto-encodes
    }
    if (subCategory) {
      params = params.set('subcategory', subCategory);
    }

    return this.http.get(`${environment.botDomain}${userApi.classicalChat}`, { params });
  }


  // Add this method to your shared service
  raiseTicket(description: string, panelistId: number, category:string, subCategory: string) {
    const payload = {
      query: description,
      panelist_id: panelistId,
      path: [category, subCategory],
      language_code: 'EN'
    };
    return this.http.post(`${environment.botDomain}${userApi.raiseTicket}`, payload);
  }

  truncateText(value: string, limit: number): { text: string; isTruncated: boolean } {
  if (!value) {
    return { text: '', isTruncated: false };
  }

  if (value.length <= limit) {
    return { text: value, isTruncated: false };
  }

  return {
    text: value.substring(0, limit) + '...',
    isTruncated: true
  };
}
}
